import { getColorMappings } from "components/ColorComponent/ColorComponent";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";

const PageTitle = (props) => {
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const { barColor, tableBorder } = getColorMappings(sidenavColor);
  return (
    <MDBox
      mx={2}
      mt={-3}
      // mb={1.5}
      py={2}
      px={2}
      sx={{ background: barColor }}
      variant="gradient"
      bgColor={tableBorder}
      // style={{backgroundColor:"#1ed6c9"}}
      borderRadius="lg"
      coloredShadow={sidenavColor}
    >
      <MDTypography variant="h6" color="white" style={{ height: "2px" }}>
        <div style={{ marginTop: "-12px" }}></div> {props.screenName}
      </MDTypography>
    </MDBox>
  );
};

export default PageTitle;
